const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://aiemails.research.bike/api' 
  : 'http://localhost:3000/api';

export default API_BASE_URL;
